import { useEffect, useState } from 'react';
import axios from 'axios';

const useImageFetcher = (image) => {
  const [images, setImages] = useState({});
  const token = localStorage.getItem('authToken');

  useEffect(() => {
    const fetchImages = async () => {
      if (!image?.state?.mainImage) return;
      try {
        const imageIds = Array.isArray(image.state.mainImage)
          ? image.state.mainImage
          : [image.state.mainImage];
        const imagePromises = imageIds.map(async (id) => {
          const response = await axios.get(
            `http://formmaker-api.altynlogistics.com/api/form/image/${id}`,
            {
              headers: { Authorization: `Bearer ${token}`, Accept: 'application/json' },
              responseType: 'blob',
            }
          );
          const blob = new Blob([response.data], { type: response.headers['content-type'] });
          const url = URL.createObjectURL(blob);
          return { id, url };
        });
        const imageResults = await Promise.all(imagePromises);
        const imageMap = imageResults.reduce((acc, { id, url }) => {
          acc[id] = url;
          return acc;
        }, {});
        setImages(imageMap);
      } catch (error) {
        console.error('Error fetching images:', error);
      }
    };

    fetchImages();

    return () => {
      Object.values(images).forEach((url) => URL.revokeObjectURL(url));
    };
  }, [image, token]);

  return images;
};

export default useImageFetcher;
